import { StrictMode } from 'react'
import { render, unmountComponentAtNode } from 'react-dom'

import {
  initExternalDepsForDevelopment,
  initExternalDeps,
  externalDeps,
  IExternalDeps,
} from './external-deps'
import { Root } from './root'

import './styles.scss'

if (process.env.NODE_ENV === 'development') {
  ;(async function run() {
    await initExternalDepsForDevelopment()

    render(
      <StrictMode>
        <Root />
      </StrictMode>,
      externalDeps.container.querySelector('#root'),
    )
  })().catch((error) => {
    console.log('async error:', error)
  })
} else {
  function renderApp() {
    render(
      <StrictMode>
        <Root />
      </StrictMode>,
      externalDeps.container.querySelector('#root'),
    )
  }

  ;(window as any)['app-shell'] = {
    async bootstrap(props: IExternalDeps) {
      initExternalDeps(props)
      console.log('App Shell bootstraped')
    },
    async mount(props: IExternalDeps) {
      initExternalDeps(props)

      renderApp()
    },
    async unmount() {
      const element = externalDeps.container.querySelector('#root')
      if (element != null) {
        unmountComponentAtNode(element)
      }
    },
    async update(props: Partial<IExternalDeps>) {
      for (const key of Object.keys(props)) {
        ;(externalDeps as any)[key] = (props as any)[key]
      }
      renderApp()
      console.log('update props', props)
    },
  }
}
